import { render, staticRenderFns } from "./user-avatar.vue?vue&type=template&id=01c46440&scoped=true&"
import script from "./user-avatar.vue?vue&type=script&lang=js&"
export * from "./user-avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c46440",
  null
  
)

export default component.exports